import 'normalize.css';
import '@/assets/css/base.css';

import '@/assets/css/components/btn.css';
import '@/assets/css/components/menu/side-menu.css';
import '@/assets/css/components/table.css';
import '@/assets/css/components/table-default.css';
import '@/assets/css/components/response-handler.css';
import '@/assets/css/components/title.css';
import '@/assets/css/components/pagination.scss';
import '@/assets/css/components/app-header-main.css';
import '@/assets/css/components/search.css';

import 'reflect-metadata';
import './router/hooks';

import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import siteModule from '@/store/site';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { initNotifications } from './plugins/notifications';

import AuthModule from '@/store/auth';
import UserModule from "@/store/user";
import VoxAuthModule from "@/store/voxAuth";

(async () => {
    Vue.config.productionTip = false;

    await AuthModule.profile();
    await siteModule.init();

    if (UserModule.isDoctor) {
        await VoxAuthModule.makeAuth();
    }

    sync(store, router);

    new Vue({
        router,
        store,
        vuetify,
        render: h => h(App),
    }).$mount('#app');

    // Push support is optional and must never delay rendering the application.
    void initNotifications();
})();
